<script setup>
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';
import { defineEmits } from 'vue';

defineProps({
  title: {
    type: String,
    required: true,
  },
  compact: {
    type: Boolean,
    default: false,
  },
  icon: {
    type: String,
    default: '',
  },
  emoji: {
    type: String,
    default: '',
  },
  isOpen: {
    type: Boolean,
    default: true,
  },
});

const emit = defineEmits(['toggle']);

const onToggle = () => {
  emit('toggle');
};
</script>

<template>
  <div class="text-sm">
    <button
      class="flex items-center select-none w-full rounded-xl bg-n-alpha-1 dark:bg-n-solid-2 border border-n-weak m-0 cursor-grab justify-between py-2.5 px-4 drag-handle transition-colors duration-150 hover:bg-n-alpha-2 dark:hover:bg-n-solid-3"
      :class="{ 'rounded-bl-none rounded-br-none border-b-0': isOpen }"
      @click.stop="onToggle"
    >
      <div class="flex items-center gap-2">
        <EmojiOrIcon class="inline-block w-4 text-n-slate-10" :icon="icon" :emoji="emoji" />
        <h5 class="text-n-slate-12 text-xs font-semibold uppercase tracking-wider mb-0 py-0">
          {{ title }}
        </h5>
      </div>
      <div class="flex flex-row items-center gap-1">
        <slot name="button" />
        <div class="flex justify-end text-n-slate-10">
          <fluent-icon v-if="isOpen" size="16" icon="subtract" type="solid" />
          <fluent-icon v-else size="16" icon="add" type="solid" />
        </div>
      </div>
    </button>
    <div
      v-if="isOpen"
      class="border border-t-0 border-n-weak rounded-br-xl rounded-bl-xl"
      :class="compact ? 'p-0' : 'px-3 py-4'"
    >
      <slot />
    </div>
  </div>
</template>

